/**
 * A small drawing of each commodity for the Commodities page (flat, two or three colours, 64×64), and a
 * line on why its price matters in Nigeria. Drawn here, so there are no image files to host.
 */
const svg = children => m('svg', {
  viewBox: '0 0 64 64',
  width: 56,
  height: 56,
  'aria-hidden': 'true'
}, children);
const barrel = (body, band) => svg([m('ellipse', {
  cx: 32,
  cy: 14,
  rx: 17,
  ry: 5,
  fill: band
}), m('path', {
  d: 'M15 14v36c0 2.8 7.6 5 17 5s17-2.2 17-5V14c0 2.8-7.6 5-17 5s-17-2.2-17-5z',
  fill: body
}), m('path', {
  d: 'M15 26c0 2.8 7.6 5 17 5s17-2.2 17-5M15 39c0 2.8 7.6 5 17 5s17-2.2 17-5',
  stroke: band,
  'stroke-width': 3,
  fill: 'none'
}), m('ellipse', {
  cx: 38,
  cy: 13,
  rx: 3,
  ry: 1.3,
  fill: '#1b1b1b',
  opacity: 0.5
})]);
export const ART = {
  brent: barrel('#1f2d3a', '#3d5a73'),
  wti: barrel('#2b2b2b', '#6b6b6b'),
  natgas: svg([m('path', {
    d: 'M32 6c3 10 15 15 15 30a15 15 0 0 1-30 0c0-8 4-12 7-16 1 5 3 8 6 9-2-9 0-17 2-23z',
    fill: '#2f7de1'
  }), m('path', {
    d: 'M32 30c2 5 7 7 7 13a7 7 0 0 1-14 0c0-4 2-6 4-8 0 2 1 4 3 4-1-3-1-6 0-9z',
    fill: '#9cd0ff'
  })]),
  gold: svg([m('path', {
    d: 'M8 46l6-14h20l6 14z',
    fill: '#d4a017'
  }), m('path', {
    d: 'M24 46l6-14h20l6 14z',
    fill: '#e8b923'
  }), m('path', {
    d: 'M16 32l6-14h20l6 14z',
    fill: '#f2c94c'
  }), m('path', {
    d: 'M22 20h18l-2 5H24z',
    fill: '#fff3c4',
    opacity: 0.7
  }), m('rect', {
    x: 6,
    y: 46,
    width: 52,
    height: 4,
    rx: 1,
    fill: '#b8860b'
  })]),
  silver: svg([m('circle', {
    cx: 25,
    cy: 36,
    r: 15,
    fill: '#a9b3bd'
  }), m('circle', {
    cx: 25,
    cy: 36,
    r: 11,
    fill: 'none',
    stroke: '#d9dee3',
    'stroke-width': 2
  }), m('circle', {
    cx: 39,
    cy: 28,
    r: 15,
    fill: '#c7cfd6'
  }), m('circle', {
    cx: 39,
    cy: 28,
    r: 11,
    fill: 'none',
    stroke: '#eef1f4',
    'stroke-width': 2
  }), m('text', {
    x: 39,
    y: 33,
    'text-anchor': 'middle',
    'font-size': 13,
    'font-weight': 700,
    fill: '#8a949e',
    'font-family': 'Arial'
  }, 'Ag')]),
  copper: svg([m('ellipse', {
    cx: 32,
    cy: 32,
    rx: 22,
    ry: 22,
    fill: '#b5651d'
  }), m('ellipse', {
    cx: 32,
    cy: 32,
    rx: 16,
    ry: 16,
    fill: 'none',
    stroke: '#e08a3c',
    'stroke-width': 3
  }), m('ellipse', {
    cx: 32,
    cy: 32,
    rx: 10,
    ry: 10,
    fill: 'none',
    stroke: '#e08a3c',
    'stroke-width': 3
  }), m('circle', {
    cx: 32,
    cy: 32,
    r: 4,
    fill: '#7a3f0d'
  }), m('path', {
    d: 'M52 38c6 4 8 10 6 16',
    stroke: '#e08a3c',
    'stroke-width': 3,
    fill: 'none',
    'stroke-linecap': 'round'
  })]),
  aluminium: svg([m('path', {
    d: 'M20 12h24l2 6v34l-2 6H20l-2-6V18z',
    fill: '#c9d1d9'
  }), m('path', {
    d: 'M18 18h28v4H18zM18 48h28v4H18z',
    fill: '#9aa5b1'
  }), m('rect', {
    x: 24,
    y: 27,
    width: 16,
    height: 16,
    rx: 2,
    fill: '#e9edf1'
  }), m('text', {
    x: 32,
    y: 39,
    'text-anchor': 'middle',
    'font-size': 10,
    'font-weight': 700,
    fill: '#6b7785',
    'font-family': 'Arial'
  }, 'Al')]),
  wheat: svg([m('path', {
    d: 'M32 60V18',
    stroke: '#b8892b',
    'stroke-width': 3,
    'stroke-linecap': 'round'
  }), [14, 24, 34, 44].map(y => [m('ellipse', {
    cx: 25,
    cy: y,
    rx: 7,
    ry: 4,
    transform: `rotate(-35 25 ${y})`,
    fill: '#e3b04b'
  }), m('ellipse', {
    cx: 39,
    cy: y,
    rx: 7,
    ry: 4,
    transform: `rotate(35 39 ${y})`,
    fill: '#d49a2a'
  })]), m('ellipse', {
    cx: 32,
    cy: 8,
    rx: 4,
    ry: 6,
    fill: '#e3b04b'
  })]),
  maize: svg([m('path', {
    d: 'M32 8c8 0 12 10 12 24s-5 24-12 24-12-10-12-24S24 8 32 8z',
    fill: '#f4c430'
  }), [16, 23, 30, 37, 44].map(y => m('path', {
    d: `M22 ${y}h20`,
    stroke: '#d9a514',
    'stroke-width': 1.5
  })), m('path', {
    d: 'M32 9v46',
    stroke: '#d9a514',
    'stroke-width': 1.5
  }), m('path', {
    d: 'M20 30c-8 6-10 16-6 28 6-4 12-10 14-18zM44 30c8 6 10 16 6 28-6-4-12-10-14-18z',
    fill: '#6aa84f'
  })]),
  sugar: svg([m('path', {
    d: 'M10 34l14-6 14 6-14 6z',
    fill: '#ffffff',
    stroke: '#c9ced3'
  }), m('path', {
    d: 'M10 34v14l14 6V40z',
    fill: '#eceff2',
    stroke: '#c9ced3'
  }), m('path', {
    d: 'M38 34v14l-14 6V40z',
    fill: '#dfe3e7',
    stroke: '#c9ced3'
  }), m('path', {
    d: 'M28 18l12-5 12 5-12 5z',
    fill: '#ffffff',
    stroke: '#c9ced3'
  }), m('path', {
    d: 'M28 18v12l12 5V23z',
    fill: '#eceff2',
    stroke: '#c9ced3'
  }), m('path', {
    d: 'M52 18v12l-12 5V23z',
    fill: '#dfe3e7',
    stroke: '#c9ced3'
  })]),
  coffee: svg([m('ellipse', {
    cx: 24,
    cy: 34,
    rx: 13,
    ry: 18,
    transform: 'rotate(-25 24 34)',
    fill: '#6f4e37'
  }), m('path', {
    d: 'M17 20c8 6 6 22 14 28',
    stroke: '#3e2a1d',
    'stroke-width': 2.5,
    fill: 'none',
    transform: 'rotate(-25 24 34)'
  }), m('ellipse', {
    cx: 42,
    cy: 32,
    rx: 12,
    ry: 17,
    transform: 'rotate(20 42 32)',
    fill: '#8b5e3c'
  }), m('path', {
    d: 'M36 18c7 6 5 21 12 27',
    stroke: '#4b3222',
    'stroke-width': 2.5,
    fill: 'none',
    transform: 'rotate(20 42 32)'
  })]),
  cocoa: svg([m('path', {
    d: 'M32 6c11 4 17 15 17 26S43 54 32 58c-11-4-17-15-17-26S21 10 32 6z',
    fill: '#a0522d'
  }), m('path', {
    d: 'M32 7v50M24 10c-4 8-4 36 0 44M40 10c4 8 4 36 0 44',
    stroke: '#7b3a1a',
    'stroke-width': 2,
    fill: 'none'
  }), m('ellipse', {
    cx: 50,
    cy: 48,
    rx: 5,
    ry: 7,
    transform: 'rotate(30 50 48)',
    fill: '#5a2e14'
  }), m('ellipse', {
    cx: 14,
    cy: 50,
    rx: 5,
    ry: 7,
    transform: 'rotate(-30 14 50)',
    fill: '#6b3519'
  })]),
  cotton: svg([m('path', {
    d: 'M18 44l14 14 14-14',
    fill: '#7a5230'
  }), m('circle', {
    cx: 24,
    cy: 30,
    r: 10,
    fill: '#ffffff',
    stroke: '#d6d6d6'
  }), m('circle', {
    cx: 40,
    cy: 30,
    r: 10,
    fill: '#ffffff',
    stroke: '#d6d6d6'
  }), m('circle', {
    cx: 32,
    cy: 20,
    r: 10,
    fill: '#ffffff',
    stroke: '#d6d6d6'
  }), m('circle', {
    cx: 32,
    cy: 36,
    r: 10,
    fill: '#fafafa',
    stroke: '#d6d6d6'
  })])
};

/** Why the price matters here, in one line */
export const WHY = {
  brent: "The world's main oil benchmark. Nigeria's crude is sold at prices tied to Brent, and the federal budget is built on an oil price.",
  wti: 'The US oil benchmark. It moves with Brent and with fuel prices around the world.',
  natgas: "The US gas benchmark (Henry Hub). Nigeria holds Africa's largest proven gas reserves.",
  gold: 'A store of value in uncertain times. Gold is also mined in several Nigerian states.',
  silver: 'Used in jewellery, electronics and solar panels, and held as a store of value.',
  copper: 'Used in power lines and wiring, so its price feeds into electricity and building costs.',
  aluminium: 'Used in roofing sheets, cans and window frames.',
  wheat: 'Nigeria imports most of its wheat, so the world price feeds into the cost of bread and pasta.',
  maize: 'A staple food and the main ingredient in poultry feed. Nigeria is one of Africa’s largest growers.',
  sugar: 'Most of the sugar refined in Nigeria is imported raw, so the world price shows up on shop shelves.',
  coffee: 'The world price of coffee beans, which sets what roasters and cafés pay.',
  cocoa: 'Nigeria is one of the world’s largest cocoa growers, mostly in Ondo, Cross River and Osun, and cocoa is a leading farm export.',
  cotton: 'Grown in northern Nigeria; its price matters to farmers and the textile industry.'
};

/** Tint behind each drawing */
export const TINT = {
  energy: '#e8f0f8',
  metals: '#fbf3dc',
  farm: '#eef6e6'
};
flarum.reg.add('voucha-markets', 'forum/components/commodityArt', { ART: ART,WHY: WHY,TINT: TINT, });